import api from '../api';

export const getMatches=()=> async(dispatch)=>{
    const matches=await api.get('/json-data');
    console.log("fetch matches",matches)
    dispatch({
        type:'FETCH_MATCHES',
        payload:matches.data.data
    });
}

export const getSingleMatch=(match)=>{
    console.log("from reducer",match)
    return({
        type:'GET_MATCH',
        payload:match
    })
}

export const filterData=(data)=>{
    return ({
        type:"SELECTED_PLAYERS",
        payload:data
        })
}


export const refactorPlayers=(data)=>{
    return({
        type:'REFACTOR_PLAYERS',
        payload:data
    })
}

export const getPlayers=()=> async(dispatch)=>{
    const players=await api.get('/player-data');
    dispatch({
        type:'FETCH_PLAYERS',
        payload:players.data.data
    });
}
export const getEvents=()=> async(dispatch)=>{
    const events=await api.get('/event-data');
    dispatch({
        type:'FETCH_EVENTS',
        payload:events.data.data
    });
}
